module.exports = __webpack_public_path__ + "h5/img/vip.b401fdb9.png";